import { connect } from "react-redux";

import SendTriggerMenu from "apps/messenger/components/MainWindow/SendTriggerMenu";

import {
	onChangePreferredSendTrigger,
} from "ducks/global_messaging";

const mapStateToProps = (state) => {
	const {
		preferredSendTrigger,
	} = state.globalMessaging;

	return {
		preferredSendTrigger,
	};
};

const mapDispatchToProps = {
	onChangePreferredSendTrigger,
};


export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(SendTriggerMenu);



// WEBPACK FOOTER //
// ./src/apps/messenger/containers/SendTriggerMenu.js